import type { CursorPage } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  AuditLogDetail,
  AuditLogQuery,
  AuditLogSummary,
  SecurityEventDetail,
  SecurityEventQuery,
  SecurityEventSummary,
} from './types';

export interface AuditRepository {
  listAuditLogs(query: AuditLogQuery, signal: AbortSignal): Promise<CursorPage<AuditLogSummary>>;
  getAuditLog(auditId: string, signal: AbortSignal): Promise<AuditLogDetail>;
  listSecurityEvents(
    query: SecurityEventQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<SecurityEventSummary>>;
  getSecurityEvent(eventId: string, signal: AbortSignal): Promise<SecurityEventDetail>;
}

export const auditRepositoryToken = createRepositoryToken<AuditRepository>('audit');

export const defaultAuditLogQuery = Object.freeze<AuditLogQuery>({
  cursor: '',
  pageSize: 50,
  filters: Object.freeze({
    principalActorId: '',
    principalRole: '',
    partnerId: '',
    agentId: '',
    requestId: '',
    sourceIp: '',
    from: '',
    to: '',
    action: '',
    entityType: '',
    entityId: '',
  }),
});

export const defaultSecurityEventQuery = Object.freeze<SecurityEventQuery>({
  cursor: '',
  pageSize: 50,
  filters: Object.freeze({
    principalActorId: '',
    principalRole: '',
    partnerId: '',
    agentId: '',
    requestId: '',
    sourceIp: '',
    from: '',
    to: '',
    credentialActorId: '',
    category: '',
    severity: '',
    eventCode: '',
  }),
});
